import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-1-subsection" }
const _hoisted_2 = { class: "frame-28" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-wrapper-12" }, "Prêt à transformer votre boutique ?", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-wrapper-13" }, " Rejoignez les fleuristes qui simplifient leur quotidien et développent leurs ventes avec Florisuite. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-wrapper-14" }, "Commencer votre essai gratuit", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_RouterLink, {
        to: "/inscription",
        class: "button",
        "aria-label": "Commencer votre essai gratuit"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ]))
}